import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './ITStaffingContracts.css';

const ITStaffingContracts = () => {
  const navigate = useNavigate();

  const handleTalkToUs = () => {
    // Navigate to contact page and scroll to form section
    navigate('/contact#form-section');
  };
  return (
    <div className="it-staffing-page">
      {/* HERO */}
      <section className="hero-staffing">
        <div className="hero-bg-grid"></div>
        <div className="hero-blob blob1"></div>
        <div className="hero-blob blob2"></div>
        <div className="hero-inner">
          <div className="hero-content">
            <div className="hero-label">IT Staffing Division</div>
            <h1 className="hero-title">
              <span className="accent">Contract</span>
              <span>Talent</span>
              <span className="outline">Delivered.</span>
            </h1>
            <p className="hero-sub-IT">
              From short-horizon projects to multi-year engagements — we bring pre-vetted,
              deployment-ready technical talent faster than anyone else in the market.
            </p>
            <div className="hero-cta-row">
              <Link to="/contact" className="btn-primary">Start Hiring Now</Link>
              <a href="#models" className="btn-outline">View Engagement Models</a>
            </div>
          </div>

          <div className="hero-stats-IT">
            <div className="stat-card reveal">
              <div className="stat-num">75K<sup>+</sup></div>
              <div className="stat-label">Vetted Technical Profiles in Database</div>
            </div>
            <div className="stat-card reveal reveal-delay-1">
              <div className="stat-num">1K<sup>+</sup></div>
              <div className="stat-label">Successful Contract Placements</div>
            </div>
            <div className="stat-card reveal reveal-delay-2">
              <div className="stat-num">48<sup>hr</sup></div>
              <div className="stat-label">Average Resume Turnaround Time</div>
            </div>
            <div className="stat-card featured reveal reveal-delay-3">
              <div className="stat-icon">🎯</div>
              <div>
                <div className="stat-num">92%</div>
                <div className="stat-label">First-Submission Acceptance Rate</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TAPE */}
      <div className="tape">
        <div className="tape-inner">
          <span className="tape-item">C2C Contracts</span>
          <span className="tape-item">C2H Engagements</span>
          <span className="tape-item">Long-Term Contracts</span>
          <span className="tape-item">75,000+ Vetted Profiles</span>
          <span className="tape-item">Full Stack</span>
          <span className="tape-item">Cloud & DevOps</span>
          <span className="tape-item">Data & AI</span>
          <span className="tape-item">ERP & SAP</span>
          <span className="tape-item">Cybersecurity</span>
          <span className="tape-item">QA Automation</span>
          <span className="tape-item">C2C Contracts</span>
          <span className="tape-item">C2H Engagements</span>
          <span className="tape-item">Long-Term Contracts</span>
          <span className="tape-item">75,000+ Vetted Profiles</span>
          <span className="tape-item">Full Stack</span>
          <span className="tape-item">Cloud & DevOps</span>
          <span className="tape-item">Data & AI</span>
          <span className="tape-item">ERP & SAP</span>
          <span className="tape-item">Cybersecurity</span>
          <span className="tape-item">QA Automation</span>
        </div>
      </div>

      {/* OFFERINGS */}
      <section className="offerings" id="offerings">
        <div className="container">
          <div className="hero-label">What We Offer</div>
          <h2 className="section-title">Three Models. <span className="green">One Standard.</span><br /><span className="navy">Excellence.</span></h2>

          <div className="offerings-grid">
            {/* C2C */}
            <div className="offer-card reveal">
              <div className="offer-icon">
                <svg viewBox="0 0 24 24"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
              </div>
              <div className="offer-title">Corp-to-Corp (C2C)</div>
              <div className="offer-tag">Business Entity Engagements</div>
              <p className="offer-desc">
                Structured for vendors and consulting firms, C2C contracts channel specialist talent
                directly into your project pipelines with minimal administrative overhead and full legal clarity.
              </p>
              <ul className="offer-features">
                <li>Vendor-ready, incorporation-verified professionals</li>
                <li>Statement of Work driven delivery</li>
                <li>Invoice-based billing cycles — no payroll burden</li>
                <li>Flexible ramp-up from 1 week to 6+ months</li>
                <li>Multi-vendor coordination support available</li>
              </ul>
            </div>

            {/* C2H */}
            <div className="offer-card reveal reveal-delay-1">
              <div className="offer-icon">
                <svg viewBox="0 0 24 24"><path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" /></svg>
              </div>
              <div className="offer-title">Contract-to-Hire (C2H)</div>
              <div className="offer-tag">Evaluate Before You Commit</div>
              <p className="offer-desc">
                Reduce permanent hire risk by first engaging talent on a defined contract term.
                If the fit is right — convert. Built for teams that need certainty before opening headcount.
              </p>
              <ul className="offer-features">
                <li>Trial periods of 3, 6, or 12 months</li>
                <li>Performance benchmarking during contract phase</li>
                <li>Conversion support with minimal cost-to-hire</li>
                <li>Seamless onboarding to payroll post-conversion</li>
                <li>Reduced hiring risk on niche or critical roles</li>
              </ul>
            </div>

            {/* Long-term */}
            <div className="offer-card reveal reveal-delay-2">
              <div className="offer-icon">
                <svg viewBox="0 0 24 24"><path d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
              </div>
              <div className="offer-title">Long-Term Contracts</div>
              <div className="offer-tag">Extended Project Engagements</div>
              <p className="offer-desc">
                For programs that demand sustained expertise — our long-term model ensures stability,
                knowledge continuity, and performance accountability across multi-year engagements.
              </p>
              <ul className="offer-features">
                <li>Dedicated account manager per engagement</li>
                <li>Mid-contract performance reviews & reporting</li>
                <li>Backup resource planning included</li>
                <li>Rate lock-in options for budget predictability</li>
                <li>Preferred for government, BFSI, and enterprise</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* DATABASE INFOGRAPHIC */}
      <section className="database-section">
        <div className="container">
          <div className="db-layout">
            <div className="db-content">
              <div className="hero-label">Our Edge</div>
              <h2 className="section-title">75,000+ Profiles. <br /> <span className="green">Zero Guesswork.</span></h2>
              <p className="db-desc">
                Every profile in our database has been through a structured vetting process — technical assessment, communication screening, and availability verification. You get candidates who are ready, not just interested.
              </p>
              <div className="db-highlights">
                <div className="db-highlight">
                  <div className="db-highlight-num">75K+</div>
                  <div className="db-highlight-text">
                    <strong>Live, Active Candidate Pool</strong>
                    Continuously refreshed — stale profiles auto-archived every 90 days
                  </div>
                </div>
                <div className="db-highlight">
                  <div className="db-highlight-num">100%</div>
                  <div className="db-highlight-text">
                    <strong>Multi-Layer Vetting</strong>
                    Technical + soft skills + reference checks on every profile
                  </div>
                </div>
                <div className="db-highlight">
                  <div className="db-highlight-num">1000+</div>
                  <div className="db-highlight-text">
                    <strong>Completed Contract Placements</strong>
                    Across IT services, product companies, and GCCs
                  </div>
                </div>
              </div>
            </div>
            <div className="db-visual">
              <div className="hero-label">Technology Coverage</div>
              <div className="tech-wheel">
                <div className="tech-tag">Java</div>
                <div className="tech-tag">Python</div>
                <div className="tech-tag">.NET</div>
                <div className="tech-tag">React</div>
                <div className="tech-tag">Node.js</div>
                <div className="tech-tag">Angular</div>
                <div className="tech-tag">AWS</div>
                <div className="tech-tag">Azure</div>
                <div className="tech-tag">GCP</div>
                <div className="tech-tag">DevOps</div>
                <div className="tech-tag">Kubernetes</div>
                <div className="tech-tag">Terraform</div>
                <div className="tech-tag">SAP</div>
                <div className="tech-tag">Salesforce</div>
                <div className="tech-tag">ServiceNow</div>
                <div className="tech-tag">Workday</div>
                <div className="tech-tag">Tableau</div>
                <div className="tech-tag">Spark</div>
                <div className="tech-tag">Kafka</div>
                <div className="tech-tag">ML/AI</div>
                <div className="tech-tag">Selenium</div>
                <div className="tech-tag">Cypress</div>
                <div className="tech-tag">QA</div>
                <div className="tech-tag">Security</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="process" id="models">
        <div className="container">
          <div className="hero-label">How It Works</div>
          <h2 className="section-title">From Requirement <br /> to <span className="green">Deployment</span> — Fast.</h2>
          <div className="process-flow-ISC">
            <div className="step-contact">
              <div className="step-num-ISC">1</div>
              <div className="step-title-contract">Requirement Intake</div>
              <div className="step-desc-contract">Share job description, tech stack, timeline, and budget. We ask the right questions.</div>
            </div>
            <div className="step-contact">
              <div className="step-num-ISC">2</div>
              <div className="step-title-contract">Database Search</div>
              <div className="step-desc-contract">Our team scours the 75K+ pool for exact-match vetted profiles — no external sourcing delays.</div>
            </div>
            <div className="step-contact">
              <div className="step-num-ISC">3</div>
              <div className="step-title-contract">Shortlist Delivery</div>
              <div className="step-desc-contract">You receive a curated shortlist within 48 hours — with screening notes and availability status.</div>
            </div>
            <div className="step-contact">
              <div className="step-num-ISC">4</div>
              <div className="step-title-contract">Interviews & Selection</div>
              <div className="step-desc-contract">We coordinate scheduling, facilitate technical rounds, and handle offer communication.</div>
            </div>
            <div className="step-contact">
              <div className="step-num-ISC">5</div>
              <div className="step-title-contract">Onboard & Go</div>
              <div className="step-desc-contract">Contracts executed. Background checked. Talent ready for Day 1 deployment.</div>
            </div>
          </div>
        </div>
      </section>

      {/* ANALYTICS SECTION */}
      {/* <section className="analytics">
        <div className="container">
          <div className="hero-label">By the Numbers</div>
          <h2 className="section-title" style={{ color: "var(--white)" }}>Performance That <span className="green">Speaks.</span></h2>

          <div className="analytics-grid">

            <div className="analytics-card reveal">
              <div className="card-title">Contract Placements YoY</div>
              <div className="big-metric">
                <div className="metric-main">1K<span style={{ color: 'var(--green)', fontSize: '64px', verticalAlign: 'baseline' }}>+</span></div>
                <div className="metric-sub">Successful deployments across India, US & GCC clients</div>
              </div>
              <div className="sparkline">
                <svg viewBox="0 0 300 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="sg" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#7DC242" stopOpacity="0.4" />
                      <stop offset="100%" stopColor="#7DC242" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                  <path d="M0,55 L30,48 L60,42 L90,38 L120,30 L150,26 L180,20 L210,15 L240,10 L270,6 L300,2 L300,60 L0,60 Z" fill="url(#sg)" />
                  <path d="M0,55 L30,48 L60,42 L90,38 L120,30 L150,26 L180,20 L210,15 L240,10 L270,6 L300,2" fill="none" stroke="#7DC242" strokeWidth="2" />
                </svg>
              </div>
            </div>

            <div className="analytics-card reveal reveal-delay-1">
              <div className="card-title">Placement by Engagement Type</div>
              <div className="donut-wrap">
                <div className="donut"></div>
                <div className="donut-legend">
                  <div className="legend-item"><div className="legend-dot" style={{ background: 'var(--green)' }}></div>C2C — 45%</div>
                  <div className="legend-item"><div className="legend-dot" style={{ background: 'var(--navy-light)' }}></div>Long-Term — 27%</div>
                  <div className="legend-item"><div className="legend-dot" style={{ background: '#2dd4bf' }}></div>C2H — 13%</div>
                  <div className="legend-item"><div className="legend-dot" style={{ background: 'rgba(255,255,255,0.2)' }}></div>Other — 15%</div>
                </div>
              </div>
            </div>

            <div className="analytics-card wide reveal reveal-delay-2">
              <div className="card-title">Top Technical Domains — Placements</div>
              <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-end' }}>
                <div style={{ flex: `1` }}>
                  <div className="bar-chart">
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div className="bar" style={{ height: '95%', width: '100%' }}></div>
                      <div className="bar-label">Cloud</div>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div className="bar" style={{ height: '85%', width: '100%' }}></div>
                      <div className="bar-label">Backend</div>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div className="bar" style={{ height: '75%', width: '100%' }}></div>
                      <div className="bar-label">Frontend</div>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div className="bar" style={{ height: '70%', width: '100%' }}></div>
                      <div className="bar-label">DevOps</div>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div className="bar" style={{ height: '60%', width: '100%' }}></div>
                      <div className="bar-label">Data/AI</div>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div className="bar" style={{ height: '55%', width: '100%' }}></div>
                      <div className="bar-label">ERP</div>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div className="bar" style={{ height: '45%', width: '100%' }}></div>
                      <div className="bar-label">QA</div>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div className="bar" style={{ height: '38%', width: '100%' }}></div>
                      <div className="bar-label">Security</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="analytics-card reveal reveal-delay-3">
              <div className="card-title">Average Fill Time</div>
              <div className="big-metric">
                <div className="metric-main">48<span style={{ color: 'var(--green)', fontSize: '64px', verticalAlign: 'baseline' }}>hr</span></div>
                <div className="metric-sub">From receipt of JD to first shortlist delivery</div>
              </div>
            </div>

            <div className="analytics-card reveal reveal-delay-4">
              <div className="card-title">First-Round Acceptance</div>
              <div className="big-metric">
                <div className="metric-main">92<span style={{ color: 'var(--green)', fontSize: '64px', verticalAlign: 'baseline' }}>%</span></div>
                <div className="metric-sub">Client interviews resulting in hire from first submission</div>
              </div>
            </div>

          </div>
        </div>
      </section> */}

      {/* WHY US SECTION*/}
      <section className="why">
        <div className="container">
          <div className="hero-label">Our Difference</div>
          <h2 className="section-title">Not Just a Vendor.<br /><span className="navy">A Talent</span> <span className="green">Partner.</span></h2>

          <div className="why-grid">
            <div className="why-points">
              <div className="why-point reveal">
                <div className="why-icon">🔍</div>
                <div>
                  <div className="why-point-title">Pre-Vetted. Not Just Pre-Screened.</div>
                  <p className="why-point-desc">Every profile undergoes a 3-step vetting process — technical assessment, communication benchmark, and real-world project verification before entering our active pool.</p>
                </div>
              </div>
              <div className="why-point reveal reveal-delay-1">
                <div className="why-icon">⚡</div>
                <div>
                  <div className="why-point-title">Speed Without Compromise</div>
                  <p className="why-point-desc">Our internal database eliminates sourcing lag. When you send a requirement, we're matching — not searching. That's why our shortlists arrive in 48 hours, not 48 days.</p>
                </div>
              </div>
              <div className="why-point reveal reveal-delay-2">
                <div className="why-icon">🔗</div>
                <div>
                  <div className="why-point-title">Compliance-Ready Contracting</div>
                  <p className="why-point-desc">Our legal and compliance stack handles NDAs, MSAs, IP agreements, and background checks — ensuring every engagement is airtight from day one.</p>
                </div>
              </div>
              <div className="why-point reveal reveal-delay-3">
                <div className="why-icon">📊</div>
                <div>
                  <div className="why-point-title">Full Transparency, Always</div>
                  <p className="why-point-desc">Real-time status updates, detailed screening notes, and clear timelines. You're never left guessing about where your requirement stands.</p>
                </div>
              </div>
            </div>

            <div className="why-visual-contract reveal">
              <div className="visual-tile green-bg">
                <span className="tile-big">75K+</span>
                <span className="tile-label">Active Profiles</span>
              </div>
              <div className="visual-tile navy-bg">
                <div className="tile-big">1K+</div>
                <div className="tile-label">Placements Done</div>
              </div>
              <div className="visual-tile outline-tile">
                <div className="tile-big" style={{ color: 'var(--navy)' }}>48H</div>
                <div className="tile-label" style={{ color: 'var(--gray)' }}>Shortlist SLA</div>
              </div>
              <div className="visual-tile dark-bg">
                <div className="tile-big">92%</div>
                <div className="tile-label">Acceptance Rate</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MODELS SECTION */}
      <section className="models" id="models">
        <div className="container">
          <div className="hero-label">Engagement Models</div>
          <h2 className="section-title">Choose How<br/>You <span className="green">Engage.</span></h2>

          <div className="models-row">
            <div className="model-card reveal">
              <div className="model-badge">C2C</div>
              <div className="model-title">Corp-to-Corp</div>
              <p className="model-desc">Pure B2B contracting — ideal for consulting firms, system integrators, and vendors who need specialist talent on specific projects.</p>
              <ul className="model-list">
                <li>Business entity invoicing</li>
                <li>SOW-based deliverables</li>
                <li>3-month to 2-year engagements</li>
                <li>Multi-resource teams supported</li>
                <li>No employer liability for client</li>
              </ul>
            </div>

            <div className="model-card reveal reveal-delay-1">
              <div className="model-badge">C2H</div>
              <div className="model-title">Contract-to-Hire</div>
              <p className="model-desc">Audit a hire before making it permanent. Engage top talent on a trial contract — evaluate fit, then convert to full-time with confidence.</p>
              <ul className="model-list">
                <li>3 to 12-month contract phases</li>
                <li>Structured evaluation milestones</li>
                <li>Conversion at pre-agreed terms</li>
                <li>Reduces bad hire risk by 70%+</li>
                <li>Ideal for senior / niche roles</li>
              </ul>
            </div>

            <div className="model-card reveal reveal-delay-2">
              <div className="model-badge">LTC</div>
              <div className="model-title">Long-Term Contracts</div>
              <p className="model-desc">For programs demanding sustained expertise over multi-year cycles. Built for enterprise, GCC, and government with full accountability layers.</p>
              <ul className="model-list">
                <li>12 months to 3+ year engagements</li>
                <li>Dedicated account ownership</li>
                <li>Quarterly performance reviews</li>
                <li>Rate lock-in options available</li>
                <li>Succession & backup planning</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta-section">
        <div className="cta-inner">
          <div className="cta-eyebrow">Ready to Scale Your Team?</div>
          <h2 className="cta-title">75,000 Profiles.<br /><span className="green">Your Next Hire</span><br />Is Already There.</h2>
          <p className="cta-sub">
            Share your requirement today. Our team will have a curated, pre-vetted shortlist on your desk within 48 hours.
          </p>
          <div className="cta-actions" style={{ marginBottom: '40px' }}>
            <button onClick={handleTalkToUs} className="cta-email">
              <span>📧</span> Talk to Us
            </button>
          </div>
          <p style={{ fontFamily: 'DM Mono', fontSize: '12px', letterSpacing: '3px', color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase' }}>
            No commitment required · Response within 4 business hours
          </p>
        </div>
      </section>
    </div>
  );
};

export default ITStaffingContracts;
